<template>
  <div>
    <el-dialog :visible.sync="newUserPop" width="30%" center>
      <div class="newUserPop-box">
        <p>新用户福利</p>
        <p>笔杆论文送你一天会员特权，可使用平台内所有会员功能，享受所有会员特权。<span @click="goVip">查看会员特权</span></p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default{
  data () {
    return {
      newUserPop: false
    }
  },
  created () {
    if (localStorage.getItem('isNew') == true) {
      this.newUserPop = true
    } else {
      this.newUserPop = false
    }
  },
  methods: {
    // 跳转至会员中心
    goVip () {
      this.$router.push({
        path: '/page/vip'
      })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.newUserPop-box{
  p{
    font-size: 16px;
    line-height: 25px;
    &:first-child{
      margin-bottom: 15px;
    }
    span{
      font-size: 16px;
      color: #D0A06E;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newUserPop.vue